// extracted by mini-css-extract-plugin
export default {"tableV2__headerRow":"TableHeader_tableV2__headerRow__J8YJ9"};